import {
  deleteApiV1ThreeLetterCodeClientAdminsUsersId,
  getGetApiV1ThreeLetterCodeClientAdminsUsersKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

export const useDeleteUser = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getGetApiV1ThreeLetterCodeClientAdminsUsersKey(threeLetterCode),
    (_, { arg }: { arg: number }) =>
      deleteApiV1ThreeLetterCodeClientAdminsUsersId(threeLetterCode, arg),
    options
  );
};
